import { useSelector } from "react-redux";
import DivisionTransfer from "./DivisionTransferList";
import CreateTransferRequest from "./CreateTransferRequest";
import AllowedAccess from "../../Layout/AllowedAccess";
import ErrorBoundry from "../../Services/ErrorBoundry";
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pageNoFound";


const DivisionTransferRoutes = () => {
	const { userData } = useSelector((state) => state.user);
	return (
		<Routes>
			<Route
				index
				element={
					<AllowedAccess
						role={userData.role_slug}
						allowedRoles={["super_admin","org_admin","captain","div_admin"]}
						renderNoAccess={() => <ErrorBoundry />}
						children={<DivisionTransfer />}
					/>
				}
			/>
			<Route path="create-transfer-request" element={
				<AllowedAccess
					role={userData.role_slug}
					allowedRoles={["super_admin","org_admin","captain","div_admin"]}
					renderNoAccess={() => <ErrorBoundry />}
					children={<CreateTransferRequest />}
				/>
			} />
			<Route path="*" element={<PageNotFound />} />
		</Routes>
	);
}

export default DivisionTransferRoutes;